export const USER_PROFILE_QUERY_KEY = 'userProfile';
